
import { DetailButton } from "./DetailButton";
import { PriceLockButton } from "./PriceLockButton";
import { ActivateButton } from "./ActivateButton";
import { ReportButton } from "./ReportButton";
import { useDealerUtils } from "@/hooks/dealers/useDealerUtils";

interface DealerCardActionsProps {
  activated?: boolean;
  dealerId: string;
  city?: string;
  onActivateClick?: () => void;
  isHomePage?: boolean;
  dealerName?: string;
  dealerAddress?: string;
  onReportClick?: () => void;
}

export function DealerCardActions({ 
  activated = false, 
  dealerId,
  city,
  onActivateClick,
  isHomePage = false,
  dealerName,
  dealerAddress,
  onReportClick
}: DealerCardActionsProps) {
  const { createCitySlug } = useDealerUtils();
  
  // Create slug from city name or use default
  let citySlug = city 
    ? createCitySlug(city)
    : 'roma';
    
  // Get the current URL to check if we're already on a city page
  const currentPath = window.location.pathname;
  const pathParts = currentPath.split('/');
  
  // If we're already on a city page, use that city in the URL
  // This is the critical part - we need to check if we're on a city page
  if (pathParts.length >= 3 && pathParts[1] === 'compro-oro' && pathParts[2]) {
    const currentCitySlug = pathParts[2];
    
    // Always use the current city from the URL if we're on a compro-oro page
    citySlug = currentCitySlug;
    
    // If we're on a dealer detail page, extract just the city part
    if (pathParts.length > 3) {
      // Make sure we're not using a dealer ID as a city
      const possibleDealerId = pathParts[3];
      if (possibleDealerId !== dealerId) {
        citySlug = currentCitySlug;
      }
    }
  }
  
  // Costruisci gli URL necessari per i link
  const detailsUrl = `/compro-oro/${citySlug}/${dealerId}`;
  const priceLockUrl = `/compro-oro/${citySlug}/${dealerId}?action=price-lock`;
  const activateUrl = `/compro-oro/${citySlug}/${dealerId}`;
  
  return (
    <>
      <div className="flex items-center gap-2 w-full">
        <DetailButton 
          href={detailsUrl} 
          isHomePage={isHomePage} 
        />
        
        {activated ? (
          <PriceLockButton 
            href={priceLockUrl} 
            isHomePage={isHomePage}
            dealerId={dealerId} // Passa il dealerId per il controllo crediti
          />
        ) : (
          <ActivateButton 
            href={activateUrl} 
            isHomePage={isHomePage} 
          />
        )}
        
        <ReportButton 
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onReportClick?.();
          }}
          isHomePage={isHomePage}
        />
      </div>
    </>
  );
}
